<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('Corridor')"
      :active.sync="isSidebarActiveLocal"
      @close="closeCorridorPopup"
      @cancel="closeCorridorPopup"
    >
      <b-row>
        <b-col>
          <vs-card>
            <b-row v-if="ROLE != 'Company'">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="'* ' + $t('Customer')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <v-select
                  color="danger"
                  v-model="customer"
                  :options="customer_choices"
                  size="small"
                  label="name"
                  v-if="data"
                  disabled
                  autocomplete
                  ref="selectElement"
                  name="customer"
                  v-validate="'required'"
                >
                </v-select>
                <v-select
                  color="danger"
                  v-model="customer"
                  :options="customer_choices"
                  size="small"
                  label="name"
                  v-else
                  autocomplete
                  ref="selectElement"
                  name="customer"
                  v-validate="'required'"
                >
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('customer')">{{
                  errors.first("customer")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('CorridorName')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="corridorName"
                  type="text"
                  name="corridorName"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('corridorName')">{{
                  errors.first("corridorName")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('CorridorCode')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="corridorCode"
                  type="text"
                  name="corridorCode"
                  v-validate="'required'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('corridorCode')">{{
                  errors.first("corridorCode")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('CorridorFloor')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="corridorFloor"
                  type="number"
                  name="corridorFloor"
                  v-validate="'required|min_value:1'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('corridorFloor')">{{
                  errors.first("corridorFloor")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 8px">
              <b-col cols="4" align-self="center">
                <b-form-group
                  :label="$t('CorridorShelf')"
                  label-for="h-first-name"
                  style="font-weight: bold; font-size: larger"
                >
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="corridorShelf"
                  type="number"
                  name="corridorShelf"
                  v-validate="'required|min_value:1'"
                  class="w-full"
                />
                <span class="text-danger text-sm" v-show="errors.has('corridorShelf')">{{
                  errors.first("corridorShelf")
                }}</span>
              </b-col>
            </b-row>
          </vs-card>
        </b-col>
      </b-row>
      <div class="items-center pl-6 mt-0 mb-0">
        <b-row align-h="end">
          <b-col cols="3" md="auto" style="padding: 0px">
            <b-button
              class="bg-danger"
              style="border-color: white"
              v-on:click="closeCorridorPopup"
            >
              <Icon
                icon="material-symbols:cancel-outline"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("Cancel") }}
            </b-button>
          </b-col>
          <b-col cols="3" md="auto">
            <b-button
              class="bg-primary"
              style="border-color: white"
              v-on:click="submitData()"
            >
              <Icon
                icon="material-symbols:save-outline"
                style="margin-right: 5px"
                width="20"
                height="20"
              />{{ $t("Save") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
export default {
  components: { Icon, vSelect, AgGridVue },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      customer: "",
      ROLE: this.$store.state.AppActiveUser.ROLE,
      customer_choices: [],
      corridorCode: "",
      corridorName: "",
      corridorFloor: 1,
      corridorShelf: 1,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      stockActColumns: [],
      stockAct: [],
    };
  },
  methods: {
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let method = "addCorridor";
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            corridorId: createdId,
            corridorName: this.corridorName,
            corridorCode: this.corridorCode,
            corridorFloor: this.corridorFloor,
            corridorShelf: this.corridorShelf,
            companyId: this.customer.value,
          };
          if (this.data) {
            method = "updateCorridor";
            obj = {
              corridorId: this.data.CorridorId,
              corridorName: this.corridorName,
              corridorCode: this.corridorCode,
              corridorFloor: this.corridorFloor,
              corridorShelf: this.corridorShelf,
              companyId: this.customer.value,
            };
          } 
          this.$store
            .dispatch("storehouse/" + method, obj)
            .then((response) => {
              if (response.status == 200) {
                vs.notify({
                  text: response.data.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
                this.closeCorridorPopup();
                this.$root.$emit("filterCorridor");
              } else {
                vs.notify({
                  text: response.data.message.toString(),
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    closeCorridorPopup() {
      this.corridorCode = "";
      this.corridorName = "";
      this.corridorFloor = 1;
      this.corridorShelf = 1;
      this.customer = "";
      this.isSidebarActiveLocal = false;
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },
  watch: {
    companydata(val) {
      this.getCustomerList();
      return val;
    },
    data(val) {
      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        if (this.ROLE != "Company") this.getCustomerList();
        const dict = { 
          custom: {
						customer:{
              required: this.$t("customerNameRequired"),
              alpha: this.$t("customerNameRequired"),
            },
            corridorName: {
              required: this.$t("corridorNameRequired"),
              alpha: this.$t("corridorNameRequired"),
            },
            corridorCode: {
              required: this.$t("corridorCodeRequired"),
              alpha: this.$t("corridorCodeRequired"),
            },
            corridorFloor: {
              required: this.$t("corridorFloorRequired"),
              alpha: this.$t("corridorFloorRequired"),
              min_value: this.$t("corridorFloorMinValue"),
            },

            corridorShelf: {
              required: this.$t("corridorShelfRequired"),
              alpha: this.$t("corridorShelfRequired"),
            },
            brand: {
              required: this.$t("brandRequired"),
              alpha: this.$t("brandRequired"),
            },
          },
        };
        Validator.localize("en", dict); 
        if (this.data) {
          this.corridorCode = this.data.CorridorCode;
          this.corridorName = this.data.CorridorName;
          this.corridorFloor = this.data.CorridorFloor;
          this.corridorShelf = this.data.CorridorShelf;
          this.customer = { value: this.data.CompanyId, name: this.data.CompanyName };
        }
      }
      return val;
    },
  },
  computed: {
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
